import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import styles from './loading.module.scss';

type LoadingProps = {
    fullScreen?: boolean;
};

const Loading = ({ fullScreen }: LoadingProps) => {
    return (
        <div
            className={classNames(
                styles['default'],
                fullScreen && styles['full-screen']
            )}
        >
            <div>
                <FontAwesomeIcon icon={faSpinnerThird} className={'fa-spin'} />
            </div>
        </div>
    );
};

export default Loading;
